// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"81":"b3555a04","235":"abf44486","285":"28e40024","434":"5dcf56bf","468":"8027d5d4","513":"6f60b83d"}[chunkId] + ".css";
};